import React from 'react';
import App from 'next/app';
import { withBlaze, reactApollo } from '@blaze-cms/nextjs-tools';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import buildConfig from '../blaze.config';
import IndexPage from '../components/IndexPage';
import { RESPONSIVE_IMAGE_CONFIG } from '../constants';
import '../styles/sass/_fonts.scss';
import '../styles/tailwind-base.css';
import '../styles/sass/main.scss';
import '../styles/globals.css';

const { ApolloProvider } = reactApollo;

class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient, router } = this.props;

    return (
      <ApolloProvider client={apolloClient}>
        <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
          <IndexPage />
          <Component {...pageProps} router={router} />
        </ResponsiveImageProvider>
      </ApolloProvider>
    );
  }
}

export default withBlaze(MyApp, buildConfig);
